import React, { Suspense, lazy } from 'react';
import { Hero } from './components/Hero';
import { ProblemAgitation } from './components/ProblemAgitation';
// Lazy load all below-fold sections to reduce initial bundle size
const NotYourFault = lazy(() => import('./components/NotYourFault').then(m => ({
  default: m.NotYourFault
})));
const Mechanism = lazy(() => import('./components/Mechanism').then(m => ({
  default: m.Mechanism
})));
const ProductIntro = lazy(() => import('./components/ProductIntro').then(m => ({
  default: m.ProductIntro
})));
const NightByNight = lazy(() => import('./components/NightByNight').then(m => ({
  default: m.NightByNight
})));
const ForWhom = lazy(() => import('./components/ForWhom').then(m => ({
  default: m.ForWhom
})));
const Testimonials = lazy(() => import('./components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const AboutAuthor = lazy(() => import('./components/AboutAuthor').then(m => ({
  default: m.AboutAuthor
})));
const Offer = lazy(() => import('./components/Offer').then(m => ({
  default: m.Offer
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const StickyUrgencyBar = lazy(() => import('./components/StickyUrgencyBar').then(m => ({
  default: m.StickyUrgencyBar
})));
export function App() {
  return <div className="min-h-screen bg-cream-50 font-sans text-slate-800" data-id="element-0">
      {/* Critical above-fold content loaded eagerly */}
      <Hero data-id="element-1" />
      <ProblemAgitation data-id="element-2" />

      {/* Below-fold content lazy loaded for performance */}
      <Suspense fallback={null} data-id="element-3">
        <NotYourFault data-id="element-4" />
        <Mechanism data-id="element-5" />
        <ProductIntro data-id="element-6" />
        <NightByNight data-id="element-7" />
        <ForWhom data-id="element-8" />
        <Testimonials data-id="element-9" />
        <AboutAuthor data-id="element-10" />
        <Offer data-id="element-11" />
        <Guarantee data-id="element-12" />
        <FinalCTA data-id="element-13" />
        <FAQ data-id="element-14" />
        <Footer data-id="element-15" />
        <StickyUrgencyBar data-id="element-16" />
      </Suspense>
    </div>;
}